import { cn } from '../../lib/utils';

interface PlanverseWordmarkProps {
  className?: string;
  /** Approximate cap height in pixels; the handwritten "v" scales along with it. */
  size?: number;
}

/**
 * "Plan" + stylized handwritten orange "v" + "erse".
 * Two families: Space Grotesk (semibold) for Plan/erse; Edu AU VIC WA NT Hand for the v.
 */
export default function PlanverseWordmark({ className, size = 52 }: PlanverseWordmarkProps) {
  return (
    <p
      className={cn(
        'font-wordmark font-semibold leading-none text-foreground whitespace-nowrap',
        className,
      )}
      style={{ fontSize: `${size}px` }}
      aria-label="Planverse"
    >
      Plan
      <span
        className="font-hand font-normal text-primary"
        style={{ fontSize: `${size * 1.15}px`, verticalAlign: '-0.05em' }}
        aria-hidden
      >
        v
      </span>
      erse
    </p>
  );
}
